import React, { useEffect, useState } from "react";
import { Task } from "../../types/Work";

interface TimerOverlayProps {
  task: Task | null;
  onStopTimer: (taskId: string) => void;
  onViewTask: (task: Task) => void;
}

export const TimerOverlay: React.FC<TimerOverlayProps> = ({
  task,
  onStopTimer,
  onViewTask,
}) => {
  const [elapsed, setElapsed] = useState(0);

  useEffect(() => {
    if (!task?.isTimerRunning || !task.currentTimerStart) {
      return;
    }

    const calculateElapsed = () => {
      const start = new Date(task.currentTimerStart!).getTime();
      const now = Date.now();
      const diff = Math.floor((now - start) / 1000);
      setElapsed(diff);
    };

    calculateElapsed();
    const interval = setInterval(calculateElapsed, 1000);

    return () => clearInterval(interval);
  }, [task]);

  if (!task?.isTimerRunning) {
    return null;
  }

  const formatTime = (seconds: number) => {
    const hours = Math.floor(seconds / 3600);
    const minutes = Math.floor((seconds % 3600) / 60);
    const secs = seconds % 60;
    return `${hours.toString().padStart(2, "0")}:${minutes
      .toString()
      .padStart(2, "0")}:${secs.toString().padStart(2, "0")}`;
  };

  return (
    <div className="timer-overlay">
      <div className="timer-overlay-content">
        <div className="timer-info">
          <div className="timer-icon">
            <i className="fas fa-stopwatch"></i>
          </div>
          <div className="timer-details">
            <div className="timer-task-name">{task.name}</div>
            <div className="timer-elapsed">{formatTime(elapsed)}</div>
          </div>
        </div>
        <div className="timer-actions">
          <button
            className="timer-view-btn"
            onClick={() => onViewTask(task)}
            title="View task details"
          >
            <i className="fas fa-eye"></i>
          </button>
          <button
            className="timer-stop-btn"
            onClick={() => onStopTimer(task.id)}
            title="Stop timer"
          >
            <i className="fas fa-stop-circle"></i>
            <span>Stop</span>
          </button>
        </div>
      </div>
      <div className="timer-progress-bar">
        <div className="timer-progress-fill"></div>
      </div>
    </div>
  );
};
